import type { TranslationKeys } from '@vocab/core';
import { useTranslations } from '@vocab/react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import translations from './.vocab';

type BucketLabelTranslationKeys = TranslationKeys<typeof translations>;

const bucketNameToKeyMap: Omit<
  Record<BUCKETS, BucketLabelTranslationKeys>,
  BUCKETS.UNKNOWN
> = {
  INBOX: 'Inbox',
  PRESCREEN: 'Prescreen',
  SHORTLIST: 'Shortlist',
  INTERVIEW: 'Interview',
  OFFER: 'Offer',
  ACCEPT: 'Accept',
  NOT_SUITABLE: 'Not Suitable',
};

export interface UseBucketLabelResponse {
  getLabelFromBucket: (bucket: BUCKETS) => string;
}

const useBucketLabel: () => UseBucketLabelResponse = () => {
  const { t } = useTranslations(translations);
  return {
    getLabelFromBucket: (bucket: BUCKETS) => {
      if (bucket === BUCKETS.UNKNOWN) {
        return bucket;
      }

      const translationKey = bucketNameToKeyMap[bucket];

      return t(translationKey);
    },
  };
};

export default useBucketLabel;
